<template>
  <div class="container-fluid mt-2">
    <h2>Service Anfrage-Vorlagen</h2>
    <div class="btn-toolbar justify-content-between" role="toolbar">
      <div class="btn-group">
        <button class="btn btn-secondary"><font-awesome-icon icon="chevron-left"/></button>
        <button class="btn btn-secondary"><font-awesome-icon icon="chevron-right"/></button>
      </div>
      <button @click="addTemplate" class="btn btn-primary">Neue Vorlage</button>
    </div>
    <b-table @row-clicked="openTemplate" class="mt-3" :items="rows" :fields="fields" striped>
      <template v-slot:cell(roles)="data">
        <span class="mr-2" v-for="r in data.item.roles" :key="r">{{ r }}</span>
      </template>
      <template v-slot:cell(bshop)="data">
        <font-awesome-icon v-show="data.item.bshop" icon="check"/>
      </template>
      <template v-slot:cell(ihand)="data">
        <font-awesome-icon v-show="data.item.ihand" icon="check"/>
      </template>
      <template v-slot:cell(ifair)="data">
        <font-awesome-icon v-show="data.item.ifair" icon="check"/>
      </template>
      <template v-slot:cell(action)="data">
        <button @click="deleteTemplate(data.item.map_id,data.index)" class="btn btn-danger"><font-awesome-icon icon="trash"/></button>
      </template>
    </b-table>
  </div>
</template>

<script>
import services from '@/modules/services.js'
import router from '@/router'

export default {
  name: 'ServiceTemplateList',
  data() {
    return {
      rows: [],
      fields: [
        {label: 'ID', key: 'map_id'},
        {label: 'Rollen', key: 'roles'},
        {label: 'Unfrei', key: 'id'},
        {label: 'bShop', key: 'bshop'},
        {label: 'iHand', key: 'ihand'},
        {label: 'iFair', key: 'ifair'},
        {label: 'Aktion', key: 'action'},
      ],
    }
  },
  created: function() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      console.log('fetch');
      var self = this;
      services.listtemplates(this,function(data) {
        self.rows = data;
      });
    },
    openTemplate: function(row) {
      router.push({name: 'ServiceTemplateEditor',params:{tid:row.map_id}});
    },
    deleteTemplate(mid,idx) {
      console.log('delete: ' + mid + "/" + idx);
      if (confirm('Möchten Sie die Service Vorlage: ' + mid + ' wirklich löschen?')) {
        var self = this;
        services.deletetemplate(this,mid,function() {
          self.rows.splice(idx,1);
          self.$bvToast.toast('Vorlage gelöscht.',{title:'Service Vorlagen',variant: 'success'});
        })
      }
    },
    addTemplate: function() {
      router.push({name: 'ServiceTemplateEditor',params:{tid:0}});
    }
  }
}
</script>
